import { Field } from "./Field";
import { SIZE_LABELS } from "@/lib/labels";

export const StepSizes = ({ form, update }) => (
  <div>
    <p className="text-sm text-slate-400 mb-6">
      Used for merch, styling, and hospitality riders. US sizing preferred.
    </p>
    <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
      {Object.entries(SIZE_LABELS).map(([key, label]) => (
        <Field
          key={key}
          label={label}
          testid={`input-size-${key}`}
          placeholder={key === "shoe" ? "e.g. 10.5" : "e.g. M / 32"}
          value={form.sizes[key]}
          onChange={(e) => update(`sizes.${key}`, e.target.value)}
        />
      ))}
    </div>
  </div>
);
